//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Grid',
  props: ['session', 'config', 'active', 'labels'],
  data: function () {
    return {}
  },
  computed: {
    visibleResultId() {
      return this.$store.state.visibleResultId
    },
    results() {
      return this.$store.state.results
    },
    emailSelections() {
      let str = ''
      this.config.forEach((el, index) => {
        if (!!this.session[el.title] && index + 1 !== this.config[this.config.length - 1].step) {
          let obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          str += `${el.title}: ${obj.name}%0D%0A`
        }
      })
      return str
    },
    queryString() {
      let str = ''
      if (this.session.step === this.config.length) {
        this.config.forEach((el, index) => {
          let _obj = el.options.find((opt) => {
            return opt.id === this.session[el.title]
          })
          str += `/${_obj.id}`
        })
      }
      return str
    },
  },
  methods: {
    ...mapActions(['fetchResults']),
    print() {
      window.print()
    },
    getEmailString(item) {
      const subject = this.labels.emailSubject
      const emailBody = `${this.labels.emailBody[0]}: ${item.caption}. ${this.labels.emailBody[1]}:%0D%0A%0D%0A${
        this.emailSelections
      }%0D%0A${this.labels.intro}%0D%0A%0D%0A• ${item.list.join('%0D%0A • ')}%0D%0A%0D%0A${this.labels.review}`
      return `mailto:?subject=${subject}&body=${emailBody}`
    },
    email(option, item) {
      let email = ''
      let subject = this.labels.emailSubject
      let emailBody = `
				${this.labels.emailBody[0]}: ${item.caption}. ${this.labels.emailBody[1]}:
				%0D%0A
				%0D%0A
				${this.emailSelections}
				%0D%0A
				${this.labels.intro}
				%0D%0A
				%0D%0A
				• ${item.list.join('%0D%0A • ')}
				%0D%0A
				%0D%0A
				${this.labels.review}
			`
      document.location = 'mailto:' + email + '?subject=' + subject + '&body=' + emailBody
    },
    selectOption(val) {
      this.$store.commit('setStepOption', { step: this.active.title, value: val.id })
      this.$emit('error', false)
      if (this.session.step === this.config.length) {
        // console.log('new result call')
        this.$store.commit('write_state', { key: 'visibleResultId', value: val.id })
        // let fetchEP = window.location.hostname === 'localhost' ? this.$root.results : `${this.$root.api}get/installationresults${this.queryString}`
        return this.fetchResults(`${this.$root.api}get/installationresults${this.queryString}`).then(() => {
          return true
        })
      }
    },
    isSelected(val) {
      return this.session[this.active.title] === val.id
    },
  },
}
